class PropertiesListsService extends CrudManager {
    path = '/realestate/lists';

}

angular
    .module('app')
    .service('propertiesListsService', [...PropertiesListsService.$inject, PropertiesListsService]);
